import React from "react";
import SalesSectionEditContainer from "../../modules/GASalesPages/containers/SalesSectionEditContainer/SalesSectionEditContainer";

const GASalesPageSection = () => {
  return <SalesSectionEditContainer />;
};

export default GASalesPageSection;
